export default {
  agreeTitle: 'Accord sur les services de marketing via « acbuy Affiliate » sur le site web acbuy',
  agreementText:
    "Bienvenue pour vous inscrire sur le site web acbuy et utiliser ses services de marketing « acbuy Affiliate ». Le présent Accord est conclu entre les partenaires de « acbuy Affiliate » (ci-après dénommés « Partie B ») et acbuy (ci-après dénommé « Partie A ») (y compris, mais sans s'y limiter, www.acbuy.com, l'application mobile d'acbuy, etc., ci-après dénommés « Site web de la Partie A ») concernant les questions liées aux services de marketing de « acbuy Affiliate ». Avant d'utiliser les services de marketing de « acbuy Affiliate » sur le site web acbuy, la Partie B doit lire attentivement tous les textes des présentes, en particulier les parties en gras, et en cliquant sur le bouton « J'ai lu et j'accepte », la Partie B est réputée avoir accepté et consenti à se conformer aux spécifications des présentes. L'Accord constitue l'accord entre la Partie B et acbuy et a force juridique. acbuy a le droit de modifier unilatéralement les articles des présentes en fonction de ses besoins commerciaux, et acbuy publiera immédiatement ces modifications sur le site web de la Partie A en cas de modification des articles des présentes, et la Partie B cessera immédiatement d'utiliser les services de marketing sur le canal de « acbuy Affiliate » si la Partie B n'est pas d'accord avec les modifications apportées aux textes des présentes, ou autrement, la Partie B sera réputée accepter les modifications apportées aux textes des présentes.\nArticle 1 Définitions 1. Consommateur : désigne le membre acbuy qui accède au site web de la Partie A pour s'inscrire",
  dashboard: 'Tableau de bord',
  hi: 'Bonjour, ',
  inviteFriends: 'Inviter des amis',
  inviteFriendsTips:
    "Invitez des amis sur acbuy, gagnez plus d'argent ! Plus vous invitez, plus vous gagnez, sans limite.",
  inviteFriendsTips1:
    'Invitez 3 comptes actifs pour obtenir les droits de vente et gagner des commissions.',
  totalInvite: "Nombre total d'utilisateurs invités",
  myTeam: 'Mon équipe',
  extractMoney: 'Commission réglée',
  noExtractMoney: 'Commission non réglée',
  inviteTitle: 'Inviter mes amis',
  copyCode: "Copier le code d'invitation",
  poster: 'Affiche exclusive',
  myLevel: 'Mon privilège ',
  youLevel: 'Votre niveau actuel',
  commissionRate: 'Taux de commission',
  experienceValue: "Valeur d'expérience ({num}/{total})",
  levelDesc: 'Description du niveau',
  invite: 'Inviter',
  revenueDetails: "Détails de l'invitation",
  registerTime: "Heure d'inscription",
  inviteType: 'Relations associées',
  userMail: "E-mail de l'utilisateur",
  bonus: 'Prime',
  myBonus: 'Ma prime',
  myBalance: 'Mon solde',
  applyWithdraw: 'Demande de retrait',
  withdrawTips:
    'Conseil : En raison des frais de transaction liés au retrait, il est recommandé de retirer un montant supérieur à 500,00 ¥.',
  bank: 'Banque',
  paypalAccount: 'Compte PayPal',
  bankAccount: 'Compte bancaire',
  bankName: 'Nom de la banque',
  withdrawAmount: 'Montant du retrait ({unit})',
  bonusDetail: 'Détail de la prime',
  directCommission: 'Détails de la commission directe',
  indirectCommission: 'Détails de la commission indirecte',
  tradeTime: 'Heure de la transaction',
  packNo: 'Numéro de colis',
  actCommission: 'Commission',
  settlementTime: 'Heure de règlement',
  levelName: "Niveau d'ambassadeur",
  packStatus: 'Statut du colis',
  directExplain: 'Taux de commission',
  indirectExplain: "Commission sur les frais d'expédition des invités secondaires",
  experienceExplain: "Valeur d'expérience",
  withdrawRecord: 'Historique des retraits',
  withdrawTime: 'Heure du retrait',
  serialNo: 'N° de série',
  withdrawStatus: 'Statut du retrait',
  team: 'Équipe',
  levelUp: 'Niveau supérieur',
  teamInfo: "Informations sur l'équipe",
  teamNum: "Nombre d'utilisateurs dans l'équipe",
  monthCommission: 'Commission estimée pour ce mois',
  accCommission: 'Commission de règlement cumulée',
  teamMember: "Membre de l'équipe",
  promotedMember: 'Membre promu',
  invitationTime: "Heure d'invitation",
  inviter: 'Inviteur',
  promotionTime: 'Heure de promotion',
  IBAN: 'IBAN',
  swiftCode: 'Code Swift',
  bankAddress: 'Adresse de la banque',
  setting: 'Paramètres',
  profile: 'Profil',
  withdrawMethod: 'Méthode de retrait',
  myPrerogative: 'Mon privilège',
  verifyEmail: 'Vérifiez votre e-mail',
  sendCodeTips:
    'Nous avons envoyé un code de vérification à <strong>{email}</strong>. Entrez le code ci-dessous pour vérifier.',
  noGetEmail: "Vous n'avez pas reçu votre e-mail ?",
  codeErrorTips: 'Erreur de code, veuillez réessayer',
  resendTime: 'Renvoyer le code ({time}s)',
  or: 'ou',
  contactService: 'Contacter le service client en ligne',
  addMethod: 'Nouvelle méthode de retrait',
  editMethod: 'Modifier la méthode de retrait',
  rePaypalAccount: 'Saisir à nouveau le compte PayPal',
  directInvite: 'Invitation directe',
  indirectInvite: 'Invitation indirecte',
  noSameAccount: 'Le compte est différent du compte confirmé',
  noAddWithdrawMethod: "Vous n'avez pas ajouté de méthode de retrait",
  statusEnum: {
    0: 'À émettre',
    1: 'En cours de diffusion',
    2: 'Diffusion réussie',
    3: "Échec de l'approvisionnement",
    4: 'Retrait annulé',
  },
  userDetail: "Détail de l'utilisateur",
  balance: 'Solde du compte',
  withdrawMax: 'Montant supérieur à 500,00 ¥',
  addPaypalAccount: 'Ajouter un compte Paypal',
  addBankAccount: 'Ajouter un compte bancaire',
  noPaypalAccount: 'Aucun compte Paypal',
  noBankAccount: 'Aucun compte bancaire',
  estimated: 'Signé pour',
  notEstimated: 'Non signé pour',
  actual: 'Réel',
  estiamte: 'Estimation',
  directRealtion: 'Relation directe',
  indirectRealtion: 'Relation indirecte',
  experienceValueText: "Valeur d'expérience",
  relatedParcel: 'Colis associé',
  empiricalValue: 'Valeur empirique',
  acquiringTime: "Heure d'acquisition",
  relatedEmail: 'E-mail associé',
  relatedUsers: 'Utilisateurs associés',
  balanceDetail: 'Détail du solde',
  commissionDetail: 'Détail de la commission',
  details: 'Détails',
  question1:
    "Une fois que l'utilisateur invité a complété le colis, son statut sera mis à jour à « Activé »",
  question2:
    'La commande a été complétée et la commission a été transférée sur votre compte de solde',
  question3:
    'Commission pour toutes les commandes « réception non confirmée ». La commande sera vérifiée dans un délai de 30 à 60 jours, puis la commission sera transférée sur votre compte de solde',
  activatedUser: 'Utilisateur activé',
  bankTip: 'Frais de traitement du retrait : 2 % du montant du retrait',
  selectWithdrawMethod: 'Sélectionner le compte de retrait',
  currentWithdrawAmount: 'Montant retirable actuel',
  modify: 'Modifier',
  bonusBalance: 'Solde disponible de la prime',
  balanceTips1:
    '1. Paiement de la commission de règlement pour le mois précédent le 1er (UTC+8) de chaque mois',
  balanceTips2:
    "2. Le 1er (UTC+8) au 10 (UTC+8) de chaque mois est la date de retrait, et vous pouvez choisir de retirer du 1er (UTC+8) au 10 (UTC+8). Nous vous transférerons les fonds avant le 20 (UTC+8), et après le transfert, nous vous informerons du résultat du transfert par e-mail. En même temps, vous pouvez vérifier les informations relatives au transfert dans l'historique des retraits.",
  income: 'Revenu',
  expenditure: 'Dépense',
  commissionSettlement: 'Règlement de la commission',
  commissionWithdrawal: 'Retrait de la commission',
  withdrawalCancellation: 'Annulation du retrait',
  activeStatus: 'Statut actif',
  settlePackageNum: 'Quantité de colis',
  activeTime: "Heure d'activation",
  orderTime: 'Heure de soumission du colis',
  orderUser: 'Utilisateur de la commande',
  actualFreight: 'Paiement du fret réel',
  estimatedCommission: 'Commission estimée',
  withdrawAccount: 'Compte de retrait',
  withdrawType: 'Type de retrait',
  withdrawTypeEnum: {
    2: 'Retirer vers le solde',
    0: 'Retirer vers la banque',
  },
  applyTime: 'Date de la demande',
  withdrawStatusEnum: {
    0: "En cours d'examen",
    1: 'En cours de retrait',
    2: 'Retrait réussi',
    3: 'Retrait refusé',
    4: 'Retrait annulé',
  },
  bankEndNumber: 'Numéro de fin de carte bancaire',
  cancelWithdraw: 'Annuler le retrait',
  withdrawalDetails: 'Détails du retrait',
  transferVoucher: 'Justificatif de virement',
  cancelWithdrawConfirm: "Confirmation d'annulation du retrait",
  delPackageHint:
    "Après avoir confirmé l'annulation du retrait, le montant de retrait correspondant sera retourné à votre solde de commission",
  withdrawTip:
    'Le 1er (UTC+8) au 10 (UTC+8) de chaque mois sont les jours de retrait, et vous pouvez choisir de retirer du 1er (UTC+8) au 10 (UTC+8)',
  hasLogOff: 'Se déconnecter',
}
